const { getElements } = window.BAO.Utils

export class ProductNavigation extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['list', 'link']
  }

  constructor () {
    super()

    this.handleIntersection = this.handleIntersection.bind(this)
    this.observer = new IntersectionObserver(this.handleIntersection)
  }

  setupListeners () {
    super.setupListeners()

    this.els.link.elements.forEach(link => {
      this.listeners.add(link, 'mouseover', event =>
        this.setActiveLink(event.currentTarget),
      )

      this.listeners.add(link, 'focus', event =>
        this.setActiveLink(event.currentTarget),
      )
    })

    this.observableRegions.forEach(region => {
      this.observer.observe(region)
    })
  }

  /** @param {HTMLAnchorElement} link */
  setActiveLink (link) {
    this.els.link.elements.forEach(element => {
      element.classList.toggle(this.dataset.activeClass, link === element)
    })

    this.moveBackground()
  }

  moveBackground () {
    this.els.list.element.style.setProperty(
      this.dataset.activeIndexProperty,
      this.activeLinkIndex,
    )
  }

  /** @param {IntersectionObserverEntry[]} entries */
  handleIntersection (entries) {
    const firstVisibleRegion = entries.find(entry => entry.isIntersecting)

    if (!firstVisibleRegion) {
      return
    }

    const { id } = firstVisibleRegion.target
    const relatedLink = this.els.link.elements.find(
      link => link.hash === `#${id}`,
    )
    this.setActiveLink(relatedLink)
  }

  get activeLinkIndex () {
    return this.els.link.elements.findIndex(link =>
      link.classList.contains(this.dataset.activeClass),
    )
  }

  /** @returns {HTMLElement[]} */
  get observableRegions () {
    const selector = this.els.link.elements.map(link => link.hash).join(', ')
    return getElements(selector)
  }
}

if (!customElements.get('product-navigation')) {
  customElements.define('product-navigation', ProductNavigation)
}
